import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./BusinessBio.css";
import flashMessage from '../HelperFunctions';


function BusinessBio({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `Tell your AI receptionist about you or your business here. For example, "I'm a real estate agent in San Francisco, and I help people buy and sell homes."`;

  const typingTimer = useRef(null);
  const servicesInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div className="customize-ai-section">
      <span> About Your Business </span>
      <textarea
        data-say-id="knowledge-base-about-business"
        ref={servicesInputRef}
        className="business-bio-text"
        placeholder={placeholderText}
        defaultValue={organization.business_bio}
        onChange={handleInputChange}
      />

    </div>

  );
}

export default BusinessBio
